import { render, staticRenderFns } from "./OverlayContainer.vue?vue&type=template&id=370825d0&"
import script from "./OverlayContainer.vue?vue&type=script&lang=js&"
export * from "./OverlayContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports